import AuthenticatedLayout from '../../Layouts/AuthenticatedLayout';
import Lottie from "lottie-react";
import lottie_comingsoon from "../../images/lottie_comingsoon.json";
import { Head } from '@inertiajs/react';

const ManageInsights = ({ auth }) => {
  return (
    <AuthenticatedLayout
        user={auth.user}
        header="Insights"
    >
        <Head title="Insights" />

        <div className="py-12">
            <div className="w-full mx-auto px-6 lg:px-12">
                <div className="bg-white overflow-hidden shadow-md sm:rounded-lg">
                    <div className="p-6">
                        <div className="flex items-center justify-center">
                            <div className="flex flex-col items-center justify-center w-full gap-8 px-8">
                                <h3 className='text-xl lg:text-4xl text-center mx-auto text-slate-400'>Insights</h3>

                                <div className="lg:container mx-auto lg:w-1/2 h-auto">
                                    <Lottie animationData={lottie_comingsoon} />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AuthenticatedLayout>
  )
}

export default ManageInsights
